import { useMutation } from "react-query";
import http from "infra/http";
import { CotacaoAprovarItemsForm } from "../typings";

function useAprovarItemsCotacao(id?: string, cotacaoId?: string) {
  return useMutation(
    (data: { items: CotacaoAprovarItemsForm[] }) => {
      return http.post(
        `/v1/orcamento/${id}/cotacao/${cotacaoId}/aprovar`,
        data
      );
    },
    { retry: false }
  );
}

export default useAprovarItemsCotacao;
